<div class="sell-page">

  <!-- HERO -->
  <section class="hero hero--cinematic"
           [style.background-image]="'linear-gradient(rgba(31,68,65,0), rgba(31,68,65,0)), url(' + heroImage + ')'">
    <div class="hero-ferrari" [style.background-image]="'url(' + heroImage + ')'" aria-hidden="true"></div>
    <div class="container">
      <div class="hero-single">
        <p class="eyebrow eyebrow--light">PlateX sell</p>
        <h1 class="display display--light">Sell your plate.</h1>
        <p class="lede lede--light">
          Get an instant valuation, understand likely demand, and place your plate in front of the right buyers.
        </p>

        <pla-plate-x-val-band
          (valuationSubmitted)="onValuationSubmitted($event)"></pla-plate-x-val-band>

        <pla-plate-x-pulse-rail></pla-plate-x-pulse-rail>
      </div>
    </div>
  </section>

  <!-- FLOW -->
  <pla-plate-x-flow [soldExample]="soldExample"></pla-plate-x-flow>

  <!-- LIVE MARKET -->
  <pla-plate-x-live-market></pla-plate-x-live-market>

  <!-- LIQUIDITY -->
  <section class="section-pad">
    <div class="container">
      <div class="liquidity-grid">
        <div class="liquidity-intro">
          <p class="eyebrow">Practical reality</p>
          <h2 class="section">What makes a plate <span class="em">actually liquid?</span></h2>
          <p class="body" style="margin-top: 14px;">
            Most sellers want to know whether their plate will sell quickly or slowly. The honest answer comes down to three things: how the plate reads, how rare its format is, and how many close substitutes exist for the same content.
          </p>
          <p class="body" style="margin-top: 12px;">
            A plate like <span class="plate sm">HSS 23</span> reads as a recognisable initials-format with limited substitutes &mdash; naturally liquid, the kind of plate that moves quickly. A plate like <span class="plate sm">AB25 TOM</span> reads cleanly, but TOM is one of the most-searched names with dozens of substitutes across the market (AB??TOM and ??25TOM patterns are dense) &mdash; dealer appetite is more limited. Neither is wrong; they just need different routes.
          </p>
        </div>

        <div class="liquidity-cards">
          <pla-plate-x-liquidity-card
            icon="readability"
            title="Content readability"
            body="How clearly the plate reads as a word, name or pattern. Combined-reading plates (KR15 HNA → KRISHNA) command strong premiums."></pla-plate-x-liquidity-card>

          <pla-plate-x-liquidity-card
            icon="scarcity"
            title="Format scarcity"
            body="Dateless and short-prefix plates have fixed supply. Current-style plates are more abundant. Scarcity drives floor value."></pla-plate-x-liquidity-card>

          <pla-plate-x-liquidity-card
            icon="substitutes"
            title="Substitute count"
            body="If many similar plates exist for the same name or content, dealer urgency drops. Unique combinations command immediate offers."></pla-plate-x-liquidity-card>
        </div>
      </div>
    </div>
  </section>

  <!-- SCENARIOS -->
  <section class="section-pad scenarios-section">
    <div class="container">
      <div class="scenarios-shell">
        <div class="scenarios-head">
          <p class="eyebrow">How it actually plays out</p>
          <h2 class="section">Two recent plates &mdash; <span class="em">two different routes.</span></h2>
          <p class="body" style="margin-top: 12px; max-width: 600px;">
            Not every plate moves the same way. These are real trajectories from the PlateX network &mdash; one liquid, one slower &mdash; showing how the system adapts.
          </p>
        </div>

        <div class="scenarios-grid">
          <pla-plate-x-scenario-card
            registration="CAS 5H"
            meta="Cash-bid · 9 days"
            body="Listed and routed to dealers. Two cash bids returned within days — £5,600 and £7,300. Seller accepted the higher bid; DVLA transfer completed in 9 days and the plate moved into dealer stock."
            [trail]="cas5HTrail"></pla-plate-x-scenario-card>

          <pla-plate-x-scenario-card
            registration="M42 KET"
            meta="Listing route · weeks not days"
            body="No cash bid initially. Routed to a listing dealer who marketed the plate on their site over a longer horizon, ultimately selling at retail through their channel."
            [trail]="m42KetTrail"></pla-plate-x-scenario-card>
        </div>

        <p class="scenarios-foot">
          <em>Hypothetical examples &middot; individual outcomes vary</em>
        </p>
      </div>
    </div>
  </section>

  <!-- FAQ -->
  <pla-plate-x-faq></pla-plate-x-faq>

  <!-- FOUNDER + CLOSE -->
  <section class="section-pad close-section">
    <div class="container">
      <div class="foot-row">
        <div>
          <p class="quote">
            The truth is that some plates are immediately desirable to dealers, and others need time to find the right buyer. Our job is to be honest about which is which &mdash; and to give every plate the strongest realistic chance of selling well.
          </p>
          <p class="quote-attr">Hugh Lapping &middot; Founder, PlateX &middot; <span class="micro">estate agent in a former life</span></p>
        </div>

        <div class="close-block">
          <h3>Find out what your plate is worth.</h3>
          <p class="body">Free indicative valuation. Honest read on whether dealers will compete for it. No commitment.</p>
          <pla-plate-x-val-band
            (valuationSubmitted)="onValuationSubmitted($event)"></pla-plate-x-val-band>
        </div>
      </div>
    </div>
  </section>

</div>
